module.exports = __webpack_public_path__ + "img/visual_m.cbf0aef3.jpg";